// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__16v8C","requiredAsterisk":"Info_requiredAsterisk__1WoHC"};